import Tooltip from '../Tooltip';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Back from '@assets/images/back.svg';
import Info from '@assets/images/info.svg';
import { ReactNode } from 'react';
import { QUERY_PARAMS, ROUTES } from '@constants/route.constant';
import { TABS } from '@constants/common.constants';

interface BreadCrumbProps {
	title: string;
	className?: string;
	children?: ReactNode;
}

export default function BreadCrumb({ title, className = '', children }: BreadCrumbProps) {
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const [previousRoute, setPreviousRoute] = useState<string | null>(null);

	const onBack = () => {
		if (previousRoute) {
			navigate(previousRoute);
			return;
		}

		if (location.pathname.includes(ROUTES.DEALS_PRIVILEGES) && params.id) {
			navigate('/' + ROUTES.DEALS_PRIVILEGES);
			return;
		}

		if (location.pathname.includes(ROUTES.REDEMPTIONS) && params.id) {
			navigate(`/?${QUERY_PARAMS.TAB}=${TABS.REDEMPTIONS}`);
			return;
		}

		navigate('/');
	};

	useEffect(() => {
		if (location.state?.previousRoute) {
			setPreviousRoute(location.state.previousRoute);
		}
	}, []);

	return (
		<div
			data-testid='bread-crumb'
			className='w-full flex items-center justify-center tablet:justify-start text-white text-[22px] text-center mt-6 desktop:mt-10 tablet:pl-6 desktop:pl-0 relative'>
			<button className='absolute left-6 top-0 tablet:static' onClick={onBack} data-testid='back-button'>
				<Back data-testid='back-icon' />
			</button>
			<div className={`${className} tablet:pl-[48px] desktop:pl-[64px] font-semibold text-center`} data-testid='title'>
				{title}
			</div>
			{children && (
				<Tooltip
					className='left-[-247px] w-[327px] after:right-[52px]'
					displayText={
						<div className='absolute -top-3 left-2 w-6 h-6 cursor-pointer'>
							<Info data-testid='tooltip-info-icon' />
						</div>
					}>
					{children}
				</Tooltip>
			)}
		</div>
	);
}
